import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateEvent(node, nodeFields, accept) {
    const { idField, eventField, utteranceVariable } = nodeFields;
    if (!eventField || ast.isEmptyField(eventField.event))
        return;
    // Check for duplicate and required properties
    checkForDuplicateAndRequiredProperties({
        node: eventField,
        allProperties: eventField.event.properties,
        requiredProperties: [],
        parentNode: node,
        accept,
    });
    if (utteranceVariable) {
        // Get the globalProperties property. We need to ensure that the utterance
        // variables are not used in any global property.
        const globalPropertiesProp = eventField.event.properties.find((prop) => {
            return ast.isGlobalPropertiesProperty(prop);
        });
        globalPropertiesProp?.globalProperties?.members?.forEach((member) => {
            if (ast.isStringField(member.value)) {
                const memberKey = member.key.value;
                const memberValue = member.value.value;
                // Check if the utteranceVariable is being used in the member value
                if (memberValue.includes(`{${utteranceVariable}}`)) {
                    accept('error', `Utterance variables are not allowed in global_props. Found '${utteranceVariable}' in key '${memberKey}'.`, {
                        node: eventField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: node?.name,
                            propertyName: FRONTEND_PROPERTY_NAME.EVENT,
                        },
                    });
                }
            }
        });
    }
    // Get the additionalProperties and retentionDays properties
    const additionalPropertiesProp = eventField.event.properties.find((prop) => {
        return ast.isAdditionalPropertiesProperty(prop);
    });
    const retentionDaysProp = eventField.event.properties.find((prop) => {
        return ast.isRetentionDaysProperty(prop);
    });
    const retentionDays = {};
    const additionalProperies = {};
    // Iterate through the additional properties and retention days to build
    // a map of key/value for easier processing.
    retentionDaysProp?.retentionDays?.members?.forEach((member) => {
        if (ast.isStringField(member.value) ||
            ast.isBooleanField(member.value) ||
            ast.isNumbersField(member.value) ||
            ast.isEmptyField(member.value)) {
            const memberKey = member.key.value;
            const memberValue = member.value.value;
            retentionDays[memberKey] = memberValue;
        }
    });
    additionalPropertiesProp?.additionalProperties?.members?.forEach((member) => {
        if (ast.isStringField(member.value) ||
            ast.isBooleanField(member.value) ||
            ast.isNumbersField(member.value) ||
            ast.isEmptyField(member.value)) {
            const memberKey = member.key.value;
            const memberValue = member.value.value;
            additionalProperies[memberKey] = memberValue;
        }
    });
    if (utteranceVariable) {
        // Check if any property in the additionalProperties is referencing
        // the utterance variable. If it is, then ensure that we have a
        // corresponding entry in retentionDays for it.
        Object.keys(additionalProperies).forEach((key) => {
            const value = additionalProperies[key];
            if (value.includes(`{${utteranceVariable}}`)) {
                // Check the retentionDays for same key
                if (!retentionDays[key]) {
                    accept('error', `An additional_properties key '${key}' contains utterance variable '${utteranceVariable}' as a value, but retention is not specified.`, {
                        node: eventField,
                        data: {
                            id: idField?.id?.value,
                            nodeNumber: node?.name,
                            propertyName: FRONTEND_PROPERTY_NAME.EVENT,
                        },
                    });
                }
            }
        });
    }
    // The minimum value for retentionDays is 1. Ensure that all values
    // are greater than or equal to 1.
    Object.keys(retentionDays).forEach((key) => {
        const value = retentionDays[key];
        // Ensure that this is numeric and greater than or equal to 1
        const numericValue = Number(value);
        if (isNaN(numericValue) || numericValue < 1) {
            accept('error', `Property key '${key}' specified in retention_days has an invalid value. It must be at least 1.`, {
                node: eventField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.EVENT,
                },
            });
        }
    });
    // We also want to ensure that each key in the retentionDays has a
    // corresponding property in the additionalProperties.
    Object.keys(retentionDays).forEach((key) => {
        if (!additionalProperies[key]) {
            accept('error', `Property key '${key}' specified in retention_days is not present in additional_properties.`, {
                node: eventField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.EVENT,
                },
            });
        }
    });
}
//# sourceMappingURL=validate-event.js.map